import { useData } from '@hooks/useData';
import http from '@core/fetch';
import apiConfig from '@apiConfig';
import { components } from '@apiSchema';
import { SavedSelection } from '@pages/Home/context/TerritorySelectionContext';

export type OnSiteChain = components['schemas']['ChainShortSummary'];

interface TerritoryParams {
    states?: string[];
    metros?: number[];
}

interface OnSiteChainData {
    cStore: OnSiteChain[];
    grocery: OnSiteChain[];
    lodging: OnSiteChain[];
    segments: string[];
}

const REQUEST_TYPE: keyof typeof apiConfig = 'get on-site sales focus data';

const DEFAULT_DATA: OnSiteChainData = { cStore: [], grocery: [], lodging: [], segments: [] };

function buildTerritoryParams(savedSelection: SavedSelection | null): TerritoryParams {
    if (!savedSelection || savedSelection.ids.length === 0) return {};
    return savedSelection.mode === 'state'
        ? { states: savedSelection.ids }
        : { metros: savedSelection.ids.map(Number) };
}

async function getOnSiteSalesFocusData(
    savedSelection: SavedSelection | null,
): Promise<OnSiteChainData> {
    const response: components['schemas']['OnSiteChainResponse'] = await http.get(
        REQUEST_TYPE,
        buildTerritoryParams(savedSelection),
    );
    return {
        cStore: response?.cStore?.chains ?? [],
        grocery: response?.grocery?.chains ?? [],
        lodging: response?.lodging?.chains ?? [],
        segments: response?.segments ?? [],
    };
}

export function useSalesOnSiteFocusData(savedSelection: SavedSelection | null) {
    return useData(DEFAULT_DATA, getOnSiteSalesFocusData, savedSelection);
}
